import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Dashboard from '../views/Dashboard.vue';

Vue.use(VueRouter)

const routes = [

  { 
    path: '/', 
    redirect: '/login' 
  },
  { 
    path: '/login', 
    component: Home 
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

let getCookie = (name) => {
  let value = "; " + document.cookie;
  let parts = value.split("; " + name + "=");
  if (parts.length == 2) {
    return parts.pop().split(";").shift();
  }
}

// This function middleware is called before every route change
// When the token expires, it disappears
router.beforeEach((to, from, next) => {
  if (!getCookie('xsrf_token') && to.path !== '/login' && from.path !== '/login') {
    alert('Your last login session has expired, so you will now be redirected back to the login screen. Please log in again.');
    next("/login");
  }
  next();

})


export default router
